import getFocusedElementInfo from '../helpers/get-focused-element-info';
import historyStack from './history-stack';
import undoStack from './undo-stack';

const addCheckpoint = () => {
  const checkpointData = getFocusedElementInfo();
  if (!checkpointData) return;

  const stack = undoStack.get();
  const lastState = stack[stack.length - 1];

  if (lastState && lastState.innerHTML === checkpointData.innerHTML) return;

  historyStack.pushUndoAction(checkpointData);

  if (!historyStack.isRedoEmpty()) {
    historyStack.clearRedoStack();
  }
};

export default addCheckpoint;
